export default "/images/efecf84d57bdf8e798f5025c20aec503.avif";